import { render, staticRenderFns } from "./NotificationStatus.vue?vue&type=template&id=669bd957&"
import script from "./NotificationStatus.vue?vue&type=script&lang=js&"
export * from "./NotificationStatus.vue?vue&type=script&lang=js&"
import style0 from "./NotificationStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
